/**
 * Quite a lot of csv operations being used in the domain, if you find one not in this lib then
 * move it over and write / move its tests over too
 */

export const parseCSV = (csvString = '', delim = ','): string[] =>
  csvString?.split(delim) ?? []

export const isCSV = (csvString = '', delim = ','): boolean =>
  csvString?.includes(delim) && typeof csvString === 'string'

export const makeCSV = (arrayString: Array<string> = [], delim = ','): string =>
  arrayString?.join(delim) ?? ''

export const mapCSV = (
  csvString = '',
  mapFn: (part: string) => string = (str: string) => str,
  delim = ',',
) =>
  parseCSV(csvString, delim)
    .map((element) => mapFn(element))
    .join(delim)

export const nthCSV = (csvString = '', nth = 0, delim = ',') =>
  parseCSV(csvString, delim)[nth] ?? ''

export const findInCSV = (
  csvString = '',
  predicate: (csvPart: string) => boolean,
  delim = ',',
) => parseCSV(csvString, delim).find((element) => predicate(element))
